// extracted by mini-css-extract-plugin
export default {"extractButton":"styles_extractButton__IciZ-","exportText":"styles_exportText__e0Fss","extractLink":"styles_extractLink__m-bln"};